import { render, staticRenderFns } from "./TableRowMarginPerUnit.vue?vue&type=template&id=c25da16c&lang=pug&"
import script from "./TableRowMarginPerUnit.vue?vue&type=script&lang=js&"
export * from "./TableRowMarginPerUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c25da16c')) {
      api.createRecord('c25da16c', component.options)
    } else {
      api.reload('c25da16c', component.options)
    }
    module.hot.accept("./TableRowMarginPerUnit.vue?vue&type=template&id=c25da16c&lang=pug&", function () {
      api.rerender('c25da16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/performance-evaluation/table-rows/TableRowMarginPerUnit.vue"
export default component.exports